import React from "react";
import { Container, Row } from "reactstrap";
import IncidentQueueTable from "./IncidentQueue";

const IncidentDetails = () => {
  document.title = "Dashboard | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Row>
             <IncidentQueueTable />
           </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncidentDetails;
